<!-- src/components/TransferForm.vue -->

<template>
  <div class="transfer-form-container">
    <h3>Lakukan Transfer</h3>
    <form @submit.prevent="handleTransfer">
      <div class="form-group">
        <label for="sourceAccount">Dari Rekening:</label>
        <select v-model="form.source_account_id" id="sourceAccount" required>
          <option disabled value="">Pilih Rekening</option>
          <option v-for="account in props.userAccounts" :key="account.id" :value="account.id">
            {{ account.account_type }} - {{ account.account_number }} (Rp {{ formatCurrency(account.balance) }})
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="destinationNumber">Nomor Rekening Tujuan:</label>
        <input type="text" v-model="form.destination_account_number" id="destinationNumber" required />
      </div>

      <div class="form-group">
        <label for="amount">Jumlah:</label>
        <input type="number" step="0.01" v-model="form.amount" id="amount" required min="1" />
      </div>
      
      <div class="form-group">
        <label for="description">Deskripsi (Opsional):</label>
        <input type="text" v-model="form.description" id="description" />
      </div>

      <button type="submit" :disabled="isSubmitting">
        {{ isSubmitting ? 'Memproses...' : 'Transfer' }}
      </button>

      <p v-if="successMessage" class="success-message">{{ successMessage }}</p>
      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
    </form>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue';
import api from '@/services/api';

// HAPUS "import TransferForm..." dari sini

const props = defineProps({
  userAccounts: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(['transfer-success']);

const form = reactive({
  source_account_id: '',
  destination_account_number: '',
  amount: null,
  description: ''
});

const isSubmitting = ref(false);
const successMessage = ref('');
const errorMessage = ref('');

const handleTransfer = async () => {
  isSubmitting.value = true;
  successMessage.value = '';
  errorMessage.value = '';

  try {
    await api.transferFunds(form);
    successMessage.value = 'Transfer berhasil!';
    
    Object.assign(form, {
      source_account_id: '',
      destination_account_number: '',
      amount: null,
      description: ''
    });
    
    emit('transfer-success');

  } catch (error) {
    if (error.response && error.response.data.detail) {
      errorMessage.value = `Gagal: ${error.response.data.detail}`;
    } else {
      errorMessage.value = 'Terjadi kesalahan. Silakan coba lagi.';
    }
    console.error('Transfer failed:', error);
  } finally {
    isSubmitting.value = false;
  }
};

const formatCurrency = (value) => {
    const number = parseFloat(value);
    if (isNaN(number)) return '0.00';
    return number.toLocaleString('id-ID', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
</script>

<style scoped>
.transfer-form-container {
  background-color: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}
h3 {
  margin-bottom: 1.5rem;
  text-align: center;
}
button {
  width: 100%;
  /* Gunakan kelas dari global.css */
  background-color: #28a745;
  color: white;
}
button:hover {
  background-color: #218838;
}
button:disabled { background-color: #ccc; }
.success-message { color: green; margin-top: 1rem; text-align: center; }
.error-message { color: red; margin-top: 1rem; text-align: center; }
</style>